import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./index.css";
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "./context/auth.js";
import { SearchProvider } from "./context/search.js";
import { CartProvider } from './context/cart.js';
import { CartDrawerProvider } from './context/cartDrawer.js';
import { ThemeProvider } from './context/theme.js';



const root = ReactDOM.createRoot( document.getElementById( 'root' ) );
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <SearchProvider>
          <CartProvider>
            <CartDrawerProvider>
              <App />
            </CartDrawerProvider>
          </CartProvider>
        </SearchProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
